var _rect, _rect2, _path, _path2, _path3, _path4, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProductCatalogue = function SvgProductCatalogue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46.4,
    height: 46.4,
    x: 0.8,
    y: 0.8,
    fill: "#FAFBFE",
    rx: 11.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 46.4,
    height: 46.4,
    x: 0.8,
    y: 0.8,
    stroke: "#D1D9E9",
    strokeWidth: 1.6,
    rx: 11.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#productCatalogue_svg__a)",
    d: "M41.095 25.807 21.484 36.6a2.22 2.22 0 0 1-3.019-.876l-6.404-11.637a2.22 2.22 0 0 1 .875-3.018l19.612-10.793a2.22 2.22 0 0 1 3.018.875L41.97 22.79a2.22 2.22 0 0 1-.875 3.018"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.608 25.04.958 1.742a.71.71 0 0 0 .965.28l20.688-11.386a.71.71 0 0 0 .28-.965l-.958-1.742a.71.71 0 0 0-.965-.28L13.888 24.077a.71.71 0 0 0-.28.964"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#productCatalogue_svg__b)",
    d: "M36.42 20.648H14.55c-1.525 0-2.765 1.108-2.765 2.469v13.33c0 1.36 1.24 2.468 2.765 2.468h21.87c1.525 0 2.765-1.107 2.765-2.468v-13.33c0-1.361-1.24-2.469-2.764-2.469"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#productCatalogue_svg__c)",
    d: "M19.516 27.499h-4.802c-.356 0-.644-.327-.644-.73v-3.108c0-.403.288-.73.643-.73h4.803c.355 0 .643.327.643.73v3.109c0 .402-.288.729-.643.729"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5.48,
    height: 0.913,
    x: 31.879,
    y: 23.235,
    fill: "#fff",
    rx: 0.457
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4.567,
    height: 1.522,
    x: 14.828,
    y: 32.826,
    fill: "#fff",
    rx: 0.761
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 4.567,
    height: 1.522,
    x: 20.918,
    y: 32.826,
    fill: "#fff",
    rx: 0.761
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 4.567,
    height: 1.522,
    x: 27.008,
    y: 32.826,
    fill: "#fff",
    rx: 0.761
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 4.567,
    height: 1.522,
    x: 33.098,
    y: 32.826,
    fill: "#fff",
    rx: 0.761
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 3.653,
    height: 0.913,
    x: 33.707,
    y: 24.759,
    fill: "#fff",
    rx: 0.457
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#productCatalogue_svg__d)",
    d: "M25.71 22.313a.53.53 0 0 1-.379-.156c-1.417-1.43-4.389-1.45-4.415-1.45a.53.53 0 0 1-.533-.536.537.537 0 0 1 .533-.535c.138 0 3.435 0 5.171 1.761a.537.537 0 0 1-.378.916"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#productCatalogue_svg__e)",
    d: "M7.598 22.313a.53.53 0 0 1-.535-.536.54.54 0 0 1 .157-.38c1.736-1.74 5.034-1.761 5.172-1.761a.53.53 0 0 1 .533.535.537.537 0 0 1-.533.535c-.027 0-2.999 0-4.416 1.451a.53.53 0 0 1-.378.156"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#productCatalogue_svg__f)",
    d: "M20.38 21.782h-2.662l-1.066-8.567a9.8 9.8 0 0 1 6.392 0c-1.065 3.748-1.598 5.354-2.663 8.567"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#productCatalogue_svg__g)",
    d: "M12.925 21.782h2.663l1.065-8.567a9.8 9.8 0 0 0-6.391 0c1.065 3.748 1.598 5.354 2.663 8.567"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#productCatalogue_svg__h)",
    d: "M18.783 19.102h-4.26l-1.066-8.566a9.8 9.8 0 0 1 6.392 0z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#productCatalogue_svg__i)",
    d: "M27.306 33.293c0 5.89-4.794 5.622-10.653 5.622S6 39.183 6 33.293s4.794-14.189 10.653-14.189 10.653 8.3 10.653 14.19"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#productCatalogue_svg__j)",
    d: "M20.916 18.993h-8.523c-.588 0-1.065.48-1.065 1.071 0 .592.477 1.071 1.065 1.071h8.523c.588 0 1.065-.48 1.065-1.07 0-.592-.477-1.072-1.065-1.072"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#productCatalogue_svg__k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#productCatalogue_svg__l)",
    d: "M21.514 29.848c0 2.68-2.162 4.852-4.828 4.852a4.8 4.8 0 0 1-3.552-1.567 4.85 4.85 0 0 1-1.274-3.285c0-2.68 2.16-4.852 4.826-4.852a4.78 4.78 0 0 1 3.268 1.281 4.85 4.85 0 0 1 1.56 3.571"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.668 28.694h-.657a1.6 1.6 0 0 0-.17-.415h.827a.395.395 0 0 0 .394-.396.395.395 0 0 0-.394-.396h-3.723a.395.395 0 0 0-.394.396c0 .219.176.396.394.396h1.52c.302 0 .566.168.704.415h-2.224a.395.395 0 0 0-.394.396c0 .219.176.396.394.396h2.224a.8.8 0 0 1-.703.415h-1.521a.398.398 0 0 0-.287.668l2.143 2.286a.39.39 0 0 0 .557.017c.159-.15.166-.401.017-.56l-1.517-1.62h.608c.743 0 1.369-.513 1.545-1.206h.657a.395.395 0 0 0 .394-.396.395.395 0 0 0-.394-.396"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "productCatalogue_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(145.035 16.279 13.505)scale(13.2813 11.5779)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCAD70"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "productCatalogue_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-27.4147 0 0 -24.1242 39.2 29.777)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C88EA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "productCatalogue_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-5.35308 4.28035 -3.64678 -4.56072 19.196 23.204)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCAD70"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "productCatalogue_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.25714 2.15128 -5.62254 -8.5128 24.82 20.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCAD70"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "productCatalogue_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.25714 2.15128 -5.62254 -8.5128 11.5 20.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCAD70"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "productCatalogue_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(115.263 6.579 14.274)scale(5.0653 4.31561)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "productCatalogue_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(103.631 1.672 13.117)scale(4.54221 3.86824)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "productCatalogue_svg__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(115.263 5.83 11.922)scale(5.0653 4.31561)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "productCatalogue_svg__i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-10.06039 13.90912 -8.61686 -6.23253 19.885 23.412)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "productCatalogue_svg__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-5.91897 1.72096 -2.6222 -9.0186 19.392 19.622)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCAD70"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "productCatalogue_svg__l",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(124.522 2.263 18.96)scale(9.46501 25.1174)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCAD70"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "productCatalogue_svg__k"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.86 24.994h9.653V34.7H11.86z"
  })))));
};
export default SvgProductCatalogue;